@if (open()) {
  <div class="incident-banner" role="status">
    <div class="incident-banner__inner">
      <div class="incident-banner__badge" aria-hidden="true">
        <ui-icon name="shield-01" [stroke]="1.8" />
      </div>

      <p class="incident-banner__text">
        <strong>{{ 'INCIDENT_NOTICE.TITLE' | translate }}</strong>
        {{ 'INCIDENT_NOTICE.BODY' | translate }}
      </p>

      <a class="incident-banner__link" [href]="faqUrl">
        {{ 'INCIDENT_NOTICE.READ_MORE' | translate }}
        <ui-icon name="arrow-right-01" [stroke]="2" />
      </a>

      <button
        type="button"
        class="incident-banner__close"
        [attr.aria-label]="'INCIDENT_NOTICE.CLOSE' | translate"
        (click)="dismiss()"
      >
        <ui-icon name="cancel-01" [stroke]="2" />
      </button>
    </div>
  </div>
}
